import {
  applyPolyfills,
  defineCustomElements,
} from '@meios-pagamentos/eldorado-bridge-component/loader';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './components/App';
import history from './history';
import store from './store';
import './index.css';


ReactDOM.render(
  <Provider store={store}>
    <App history={history} />
  </Provider>,
  document.getElementById('app-root'),
);


applyPolyfills().then(() => {
  defineCustomElements();
});
